export default __webpack_public_path__ + "static/media/20210530.3d4aba2f.webp";